// extracted by mini-css-extract-plugin
module.exports =  {"turns":"N1qC76zi49aDhk3QnLGu","backgroundLeft":"FZl49XS1MqsVKkE4lV8Z","backgroundRight":"b7xhWeisLbLfh9GXDSa5"};